module.exports = __webpack_public_path__ + "img/place_vertu.bb70ae92.webp";